import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
`;

export const Label = styled.p`
  font-size: var(--font-size18);
  font-weight: var(--font-weight400);
  line-height: 1.22;
  letter-spacing: 0.5px;
  color: var(--color-grey6A);
  margin-bottom: 10px;
`;
